import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"
import { Label } from "@/components/ui/label"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { createCleaner } from "~/apis/cleaners"
import { fetchProperties } from "~/apis/properties"
import routes from "~/routes"

const MESSAGING_CHANNELS = [ "sms", "whatsapp" ]

export default function NewCleaner() {
  const navigate = useNavigate()
  const [ name, setName ] = useState("")
  const [ phone, setPhone ] = useState("")
  const [ messagingChannel, setMessagingChannel ] = useState(MESSAGING_CHANNELS[0])
  const [ properties, setProperties ] = useState([])
  const [ propertyId, setPropertyId ] = useState("")
  const [ error, setError ] = useState(null)

  useEffect(() => {
    fetchProperties().then((list) => {
      setProperties(list)
      if (list.length > 0) setPropertyId(String(list[0].id))
    })
  }, [])

  async function handleSubmit(event) {
    event.preventDefault()
    setError(null)

    try {
      await createCleaner({ name, phone, messaging_channel: messagingChannel, property_id: propertyId })
      navigate(routes.cleaners)
    } catch (err) {
      setError(err.message)
    }
  }

  return (
    <div className="mx-auto max-w-md px-6 py-12">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Add cleaner</CardTitle>
        </CardHeader>
        <CardContent>
          {error && <p className="mb-4 text-sm text-destructive">{error}</p>}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="name">Name</Label>
              <Input id="name" value={name} onChange={(event) => setName(event.target.value)} />
            </div>

            <div className="space-y-1.5">
              <Label htmlFor="phone">Phone</Label>
              <Input id="phone" value={phone} onChange={(event) => setPhone(event.target.value)} />
            </div>

            <div className="space-y-1.5">
              <Label htmlFor="property">Cleans at</Label>
              <Select value={propertyId} onValueChange={setPropertyId}>
                <SelectTrigger id="property" className="w-full">
                  <SelectValue placeholder="Choose a property" />
                </SelectTrigger>
                <SelectContent>
                  {properties.map((property) => (
                    <SelectItem key={property.id} value={String(property.id)}>{property.short_name ?? property.name}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-1.5">
              <Label htmlFor="messaging_channel">Messaging channel</Label>
              <Select value={messagingChannel} onValueChange={setMessagingChannel}>
                <SelectTrigger id="messaging_channel" className="w-full">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {MESSAGING_CHANNELS.map((channel) => (
                    <SelectItem key={channel} value={channel}>{channel}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="flex gap-2">
              <Button type="submit">Add cleaner</Button>
              <Button type="button" variant="outline" onClick={() => navigate(routes.cleaners)}>Cancel</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
